/* The design board was drawn in one organisation's blue. Rather than hard-code
   it, the same ramp is rebuilt from whatever colour the organisation is themed
   in, so the tab matches the rest of the app. The mix amounts below reproduce
   the board's #006BCE / #0054A3 / #EAF3FC ... ramp to within a shade. */
const TINTS = {
  "--cg-primary-25": 0.96,
  "--cg-primary-50": 0.92,
  "--cg-primary-100": 0.84,
  "--cg-primary-200": 0.7,
};

const SHADE = 0.8; // --cg-primary-700

const parseHex = (value) => {
  const hex = String(value || "").trim().replace("#", "");
  const full =
    hex.length === 3
      ? hex
          .split("")
          .map((c) => c + c)
          .join("")
      : hex.slice(0, 6);
  if (!/^[0-9a-f]{6}$/i.test(full)) return null;
  return [0, 2, 4].map((i) => parseInt(full.slice(i, i + 2), 16));
};

const toHex = (rgb) =>
  `#${rgb.map((c) => Math.max(0, Math.min(255, Math.round(c))).toString(16).padStart(2, "0")).join("")}`;

const FALLBACK = "#006BCE";

const primaryTints = (primary) => {
  const rgb = parseHex(primary) || parseHex(FALLBACK);
  const base = toHex(rgb);
  const vars = {
    "--cg-primary": base,
    "--cg-primary-700": toHex(rgb.map((c) => c * SHADE)),
  };
  Object.entries(TINTS).forEach(([name, amount]) => {
    vars[name] = toHex(rgb.map((c) => c + (255 - c) * amount));
  });
  return vars;
};

export default primaryTints;
